import Modal from '@berlitzplatforms/micro.ui.modal'
import React from 'react'
import TransactionalModal from '@berlitzplatforms/micro.modal.transactional'
import { API_ERROR, API_ERROR_DESC } from './constants'

interface IEventOpenMaterialModal {
  open: boolean
  onClose: () => void
}

const EventOpenMaterialModal: React.FC<IEventOpenMaterialModal> = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose}>
    <TransactionalModal status="warning" title={API_ERROR} description={API_ERROR_DESC} />
  </Modal>
)

export default EventOpenMaterialModal
